import React, { forwardRef, useContext } from 'react';
import FileUpload from '@alefeducation/file-upload';
import { useTranslation } from 'react-i18next';
import {
  ATTACHMENT_CONTEXT_ACTIONS,
  useAssignmentAttachmentDispatch,
  useAssignmentAttachmentState,
} from '../AssignmentSubmission/AssignmentAttachmentContext';
import { uploadTypes } from '../common/FileUpload/constants';
import { useLanguage } from '../../utils/language';
import fireNotification from '../../utils/fireNotification';
import getFileRendererSize from '../../utils/fileRendererSize';
import {
  disablePointerEventsOnPDFRenderer,
  enablePointerEventsOnPDFRenderer,
} from '../../utils/pdfRendererStylesUtil';
import AssignmentContext from '../common/AssignmentContext/AssignmentContext';
import useLDClientWrapper from '../../featureToggles/useLDClientWrapper';
import FeatureFlags from '../../featureToggles/FeatureFlags';

const FileUploadWrapper = forwardRef((_, uploadInputRef) => {
  const {
    assignmentParams: { assignmentInstanceId, assignmentId },
  } = useContext(AssignmentContext);

  const { dir, i18n } = useTranslation();
  const { attachment } = useAssignmentAttachmentState();
  const assignmentDispatch = useAssignmentAttachmentDispatch();
  const { lang, langCode } = useLanguage();
  const ldClient = useLDClientWrapper();
  const isAzureFileStorageEnabled = ldClient.variation(
    FeatureFlags.ENABLE_AZURE_FILE_STORAGE,
    false,
  );

  const removeAttachment = () => {
    assignmentDispatch({
      type: ATTACHMENT_CONTEXT_ACTIONS.removeAttachment,
    });
  };
  return (
    <FileUpload
      configs={{
        consumerId:
          window.AssignmentAppConfig.fileService.FILE_SERVICE_CONSUMER_ID,
        uploadType: uploadTypes.submission,
        configCode:
          window.AssignmentAppConfig.fileService.TEACHER_RESPONSE_ATTACHMENT,
        videoFileDurationMins:
          window.AssignmentAppConfig.VIDEO_FILE_DURATION_MINS,
        assignmentInstanceId: assignmentInstanceId || assignmentId,
        taskInfoPollInterval:
          window.AssignmentAppConfig.TASK_INFO_POLL_INTERVAL,
        taskInfoPollTimeout: window.AssignmentAppConfig.TASK_INFO_POLL_TIMEOUT,
        enableAzureFileStorage: isAzureFileStorageEnabled,
      }}
      useAsHiddenInputFilePlaceholder={!!attachment}
      ref={uploadInputRef}
      onRemove={removeAttachment}
      onComplete={uploadResult => {
        assignmentDispatch({
          type: ATTACHMENT_CONTEXT_ACTIONS.finishedUploading,
          payload: uploadResult,
        });
      }}
      onTaskUpdate={taskInfo => {
        assignmentDispatch({
          type: ATTACHMENT_CONTEXT_ACTIONS.conversionStatusChange,
          payload: taskInfo,
        });
      }}
      onSelectFile={removeAttachment}
      onStart={() => {
        assignmentDispatch({
          type: ATTACHMENT_CONTEXT_ACTIONS.startedUploading,
        });
      }}
      onError={error => {
        fireNotification(error.errorType, langCode);
      }}
      getHiddenInputDropAreaSize={getFileRendererSize}
      onDrag={() => {
        disablePointerEventsOnPDFRenderer();
      }}
      onDragLeave={() => {
        enablePointerEventsOnPDFRenderer();
      }}
      onDrop={() => {
        enablePointerEventsOnPDFRenderer();
      }}
      language={{
        dir,
        lang,
        langCode: i18n.language,
      }}
    />
  );
});

FileUploadWrapper.displayName = 'FileUploadAttachmentTeacher';

export default FileUploadWrapper;
